<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mgnVuH/tc-custom/9781426866456.jpg?1731056076494" alt="This image is the cover for the book Love Finds a Home, Mirror Lake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Love Finds a Home, Mirror Lake
      </h1>
      <p class="bookDescription body article font2">
        <b>A widowed mom haunted by the past reluctantly allows a small-town police chief to mentor her son in this inspirational romance.</b><br/><br/>Widowed mother Emma Barlow knows her shy, studious son needs a male influence. And where better to find him than in the mentoring ministry at their local church? But when the new chief of police becomes her son’s mentor, Emma is worried. As the widow of a fallen officer, she’s nervous about letting a lawman into their lives. Especially one as handsome—and conflicted—as Jake Sutton. But when her son comes out of his shell, and even Emma finds herself smiling, she knows that love just might find a home in Mirror Lake . . . and create a new family.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathryn Springer
      </h2>
      
      <p class="authorDescription body article">Carol Award winning author Kathryn Springer grew up in a small town in northern, Wisconsin. She credits her parents, who owned a weekly newspaper,&#160; for instilling in her a love for books--which eventually turned into a desire to tell stories of her own. Her <I>Love Inspired</I> debut novel, <I>Tested by Fire</I>, was published in August of 2004. <BR /> Kathryn&#160; loves inspirational romance because&#160;she can combine&#160;her faith in God with her love for a happy ending!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6d322422